export const SIGN_IN_FORM = 'signIn';
